import { render, staticRenderFns } from "./EventsBlock.vue?vue&type=template&id=15616343&scoped=true"
import script from "./EventsBlock.vue?vue&type=script&lang=js"
export * from "./EventsBlock.vue?vue&type=script&lang=js"
import style0 from "./EventsBlock.vue?vue&type=style&index=0&id=15616343&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15616343",
  null
  
)

export default component.exports